/*
 * @providesModule AgeVerificationStyle
 *
 */

import SkillzStyle from 'SkillzStyle';
import {StyleSheet} from 'react-native';
import Sizes from 'Sizes';

const regularFontSize = Sizes.isTablet() ? 19 : 16;
const inputHeight = Sizes.isTablet() ? 74 : 62;
const inputWidth = Sizes.isTablet() ? 112 : 93;
const mediumFontSize = Sizes.isTablet() ? 16 : 14;
const largeFontSize = Sizes.isTablet() ? 24 : 20;
const smallFontSize = Sizes.isTablet() ? 14 : 12;

export default StyleSheet.create({
  container: {
    flex: 1,
  },

  navBarTitle: {
    position: 'absolute',
    bottom: Sizes.isTablet() ? 26 : 16,
    alignSelf: 'flex-end',
    ...SkillzStyle.fullStyles.fontBold,
    fontSize: largeFontSize,
    color: '#000000',
  },

  navBarContainer: {
    borderBottomColor: 'rgba(0, 0, 0, 0.2)',
    borderBottomWidth: 2,
    width: '100%',
    height: Sizes.isTablet() ? 100 : 64,
    alignContent: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
  },

  checkIcon: {
    height: largeFontSize,
    width: largeFontSize,
  },

  closeBtn: {
    alignSelf: 'center',
    position: 'absolute',
    bottom: Sizes.isTablet() ? 26 : 16,
    right: Sizes.isTablet() ? 44 : 25,
  },

  closeIcons: {
    height: Sizes.isTablet() ? 30 : 24,
    width: Sizes.isTablet() ? 30 : 24,
  },

  textContainer: {
    marginHorizontal: Sizes.isTablet() ? 230 : 40,
    marginTop: Sizes.isTablet() ? 59 : 56,
  },

  dOBContainer: {
    marginHorizontal: Sizes.isTablet() ? 230 : 40,
    marginTop: 24,
  },

  newDOBContainer: {
    marginHorizontal: Sizes.isTablet() ? 230 : 24,
    marginTop: 24,
  },

  headerText: {
    fontFamily: 'OpenSans-Bold',
    fontSize: largeFontSize,
    lineHeight: Sizes.isTablet() ? 34 : 28,
    color: '#000000',
  },

  newHeaderText: {
    ...SkillzStyle.fullStyles.fontBold,
    fontSize: 28,
    lineHeight: Sizes.isTablet() ? 34 : 28,
    textAlign: 'left',
  },

  descriptionText: {
    width: Sizes.isTablet() ? 369 : 311,
    fontFamily: 'OpenSans-Regular',
    fontSize: regularFontSize,
    alignSelf: 'center',
    lineHeight: Sizes.isTablet() ? 26 : 22,
    marginTop: Sizes.isTablet() ? 16 : 8,
    color: '#000000E5',
  },

  newDescriptionText: {
    // width: Sizes.isTablet() ? 369 : 311,
    ...SkillzStyle.fullStyles.fontRegular,
    fontSize: regularFontSize,
    alignSelf: 'center',
    lineHeight: Sizes.isTablet() ? 26 : 22,
    marginTop: Sizes.isTablet() ? 16 : 8,
    textAlign: 'left',
  },

  input: {
    marginTop: 16,
    height: inputHeight,
    width: inputWidth,
    paddingHorizontal: 12,
    borderWidth: 1,
    borderRadius: 9,
    borderColor: 'rgba(0, 0, 0, 0.4)',
  },

  inputHighlight: {
    marginTop: 16,
    height: inputHeight,
    width: inputWidth,
    paddingHorizontal: 12,
    borderWidth: 1,
    borderRadius: 8,
    borderColor: '#4890E8',
  },

  inputError: {
    marginTop: 16,
    height: inputHeight,
    width: inputWidth,
    paddingHorizontal: 12,
    borderWidth: 2,
    borderRadius: 8,
    borderColor: '#DD6952',
  },

  labelTextError: {
    fontSize: mediumFontSize,
    color: '#DD6952',
  },

  inputStyle: {
    fontSize: regularFontSize,
  },

  labelStyle: {
    fontSize: mediumFontSize,
    color: '#757575',
  },

  labelHighlightStyle: {
    fontSize: mediumFontSize,
    color: '#4890E8',
  },

  placeholderStyle: {
    fontSize: regularFontSize,
    color: '#757575',
  },

  rowContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },

  newRowContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 16,
  },

  gradient: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 5,
  },

  nextText: {
    fontSize: regularFontSize,
    alignSelf: 'center',
    fontFamily: 'OpenSans-SemiBold',
    color: '#ffffff',
  },

  nextBtn: {
    width: Sizes.isTablet() ? 374 : 311,
    borderRadius: Sizes.isTablet() ? 29 : 24,
    height: Sizes.isTablet() ? 60 : 50,
    justifyContent: 'center',
    backgroundColor: '#4890E8',
  },

  footerContainer: {
    height: '30%',
  },

  footer: {
    width: Sizes.isTablet() ? 345 : 311,
    alignSelf: 'center',
    marginTop: regularFontSize,
    flexDirection: 'row',
    flexWrap: 'wrap',
  },

  newFooter: {
    marginVertical: regularFontSize,
    alignItems: 'center',
    flexWrap: 'wrap',
    marginHorizontal: 40,
  },

  footerTextStyle: {
    fontSize: smallFontSize,
    lineHeight: regularFontSize,
    fontFamily: 'OpenSans-Regular',
  },

  newFooterTextStyle: {
    fontSize: smallFontSize,
    ...SkillzStyle.fullStyles.fontRegular,
  },

  hyperlinkStyle: {
    fontSize: smallFontSize,
    lineHeight: regularFontSize,
    color: '#4890E8',
    fontFamily: 'OpenSans-Regular',
  },

  newHyperlinkStyle: {
    fontSize: smallFontSize,
    lineHeight: regularFontSize,
    ...SkillzStyle.fullStyles.fontRegular,
  },

  errorContainer: {
    flexDirection: 'row',
    marginTop: 4,
  },

  errorIcon: {
    height: mediumFontSize,
    width: mediumFontSize,
  },

  errorMessage: {
    fontSize: smallFontSize,
    color: '#DD6952',
    fontFamily: 'OpenSans-SemiBold',
    marginLeft: 5.33,
  },
});

export const createStyles = (isDarkTheme: any, theme: any, isNewUI: boolean) => {
  const regularFontSize = Sizes.isTablet() ? 19 : 16;
  const inputHeight = Sizes.isTablet() ? 74 : 62;
  const inputWidth = Sizes.isTablet() ? 112 : 93;
  const mediumFontSize = Sizes.isTablet() ? 16 : 14;
  const largeFontSize = Sizes.isTablet() ? 24 : 20;
  return StyleSheet.create({
    newInputHighlight: {
      marginTop: 16,
      height: inputHeight,
      width: inputWidth,
      paddingHorizontal: 12,
      borderRadius: 8,
    },
    newInput: {
      marginTop: 16,
      height: inputHeight,
      width: inputWidth,
      paddingHorizontal: 12,
      borderRadius: 9,
    },
    newLabelHighlightStyle: {
      fontSize: mediumFontSize,
      color: theme.playButtonGradient[0],
    },
    newLabelStyle: {
      fontSize: mediumFontSize,
      color: isDarkTheme ? '#fff' : '#000',
    },
    newInputStyle: {
      fontSize: regularFontSize,
      color: isDarkTheme ? 'white' : 'black',
    },
    newNavBarContainer: {
      borderBottomWidth: 2,
      width: '100%',
      height: Sizes.isTablet() ? 100 : 64,
      alignContent: 'center',
      justifyContent: 'center',
      flexDirection: 'row',
      borderBottomColor: isDarkTheme ? '#ffffff20' : 'rgba(0, 0, 0, 0.2)',
    },
    newNavBarTitle: {
      position: 'absolute',
      bottom: Sizes.isTablet() ? 26 : 16,
      alignSelf: 'flex-end',
      fontFamily: 'OpenSans-Bold',
      fontSize: largeFontSize,
      color: isDarkTheme ? '#fff' : '#000',
    },
    backContainer: {
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      width: '100%',
      paddingHorizontal: 20,
      marginTop: 10,
    },
    backIcon: {
      width: 24,
      height: 24,
    },
    closeIconDarkTheme: {
      height: 15,
      width: 15,
      marginBottom: 5,
    },
    inputBackgroundDark: {
      backgroundColor: 'rgba(0, 0, 0, 0.25)',
    },
    inputBackgroundLight: {
      backgroundColor: SkillzStyle.fullStyles.viewSecondaryColor?.backgroundColor,
    },
    inputHighlightBorder: {
      borderWidth: 1,
      borderColor: SkillzStyle.fullStyles.playButtonGradient[0],
    },
    errorContainerMargin: {
      marginTop: 10,
    },
    headerTextCenter: {
      color: isDarkTheme ? 'white' : 'black',
      textAlign: 'center',
    },
    descriptionTextCenter: {
      lineHeight: 24,
      color: isDarkTheme ? '#ffffff80' : '#00000080',
      textAlign: 'center',
    },
    descriptionLineHeight: {
      lineHeight: 24,
    },
    footerTextColor: {
      color: isDarkTheme ? 'white' : 'black',
    },
    footerTextBold: {
      color: isDarkTheme ? 'white' : 'black',
      ...SkillzStyle.fullStyles.fontBold,
    },
    nextButtonStyle: {
      height: 56,
      marginHorizontal: 24,
    },
    nextButtonDisabled: {
      height: 56,
      opacity: 0.6,
      marginHorizontal: 24,
    },
    nextButtonTextStyle: {
      color: SkillzStyle.fullStyles.btnTextColorOne.color,
      ...SkillzStyle.fullStyles.fontBold,
      fontSize: 18,
    },
    containerBackground: {
      backgroundColor: isNewUI ? 'transparent' : '#ffffff',
    },
    keyboardAvoidingView: {
      height: '70%',
    },
  });
};
